import { ImageConverterState } from "../types";

interface Payload {
    payload: NonNullable<ImageConverterState["pageInfo"]>;
}

export const setPageInfo = (state: ImageConverterState, { payload }: Payload) => {
    state.pageInfo = payload;
};
